import { i18n } from "services/i18nService";

import { initialErrorState } from "views/common";

export function isValid(record) {
  const errors = initialErrorState();

  if (!record.vendor) {
    errors.messages.push(i18n("isValid.Vendor"));
    errors.entity.push("vendor");
  }

  if (!record.item) {
    errors.messages.push(i18n("isValid.Item"));
    errors.entity.push("item");
  }

  return errors;
}
